import { Stack } from '@mui/material';
import { VyDivider } from '../../../../../../../../../components/new-design/atoms';
import { GetExportedIntegrationsResponse, GetLightInvoicesResponse } from '@vy/api-definition';
import { ItemOf } from '@vy/utils';
import { INTEGRATION_TYPES } from '@vy/integrations-types';
import { MorningIntegrationStatusAccordion } from './invoice-activity-morning-sync-tab-components/MorningIntegrationStatusAccordion/MorningIntegrationStatusAccordion';
import { MorningInvoiceDetailsAccordion } from './invoice-activity-morning-sync-tab-components/MorningInvoiceDetailsAccordion/MorningInvoiceDetailsAccordion';

type InvoiceActivityMorningSyncTabProps = {
  invoice: ItemOf<GetLightInvoicesResponse['invoices']>;
  exportedInvoiceIntegrations: GetExportedIntegrationsResponse;
};

export const InvoiceActivityMorningSyncTab: React.FC<InvoiceActivityMorningSyncTabProps> = ({
  invoice,
  exportedInvoiceIntegrations,
}) => {
  const morningIntegration = findMorningIntegration(exportedInvoiceIntegrations);

  return (
    <Stack
      spacing="12px"
      sx={{
        height: 'calc(100vh - 400px)',
        overflowY: 'auto',
        scrollbarWidth: 'none',
      }}
      divider={<VyDivider />}
    >
      <MorningIntegrationStatusAccordion morningIntegration={morningIntegration} invoice={invoice} />
      <MorningInvoiceDetailsAccordion morningIntegration={morningIntegration} invoice={invoice} />
    </Stack>
  );
};

function findMorningIntegration(exportedInvoiceIntegrations: GetExportedIntegrationsResponse) {
  return exportedInvoiceIntegrations.find(
    (exportedIntegration) => exportedIntegration.integration === INTEGRATION_TYPES.MORNING,
  );
}
